module.exports = __webpack_public_path__ + "img/rr.840e6a8a.png";